import AuthCall from "./auth";
import { ApiResponse, EndpointRequest } from "../types/base";
import { CrfDataApi, CrfExportFinishStatusAPI } from "../../types/crf";
import { SiteData } from "../../types/account";
import { FinishTrialReason } from "../../types/patient";

const CrfAPI = {
  getCrf: async ({ id, signal }: { id: string } & EndpointRequest) => await AuthCall.get({
    endpoint: `/secure/medical/crf/${id}`,
    signal,
  }) as ApiResponse<CrfDataApi>,
  
  uploadCrf: async ({ id, data, signal }: { id: string, data: CrfDataApi } & EndpointRequest) => await AuthCall.put({
    endpoint: `/secure/medical/crf/${id}`,
    data,
    signal,
  }),

  exportReport: async ({ site, finishStatus: finishState, finishReason, signal }: {
    site?: SiteData,
    finishStatus?: CrfExportFinishStatusAPI,
    finishReason?: FinishTrialReason,
   } & EndpointRequest) => await AuthCall.get({
    endpoint: '/secure/medical/crf/report',
    params: {
      siteId: site?.id,
      status: finishState,
      finalStatus: finishReason,
    },
    signal,
  }),
}

export default CrfAPI;